export const containerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  gap: '12px',
  height: '100%',
  minHeight: '480px',
  padding: '32px',
  borderRadius: '10px',
  border: ({ palette }) => `1px solid ${palette.border.input}`,
  backgroundColor: ({ palette }) => palette.background.paper,
};

export const getIconStyles = isError => ({
  display: 'flex',
  color: ({ palette }) => (isError ? palette.error.main : palette.text.secondary),
});

export const titleStyles = {
  color: ({ palette }) => palette.text.primary,
};

export const subtitleStyles = {
  maxWidth: '400px',
  color: ({ palette }) => palette.text.secondary,
};

export const retryStyles = {
  marginTop: '6px',
};
